/** @type {import('@alfa-site/assr-core').IAssrBuildConfig} */
const assrConfig = {
    postcss: {
        customPropertiesFile: 'node_modules/@alfalab/core-components/themes/site.css'
    },

    cssHashLen: 5,
    widgetsContexts: ['@alfa-bank', '@plotva'],
    additionalWidgetPackages: ['@plotva/common-widgets']
};

module.exports = assrConfig;
